function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteCoreTerrestrialSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 27.78125 27.78125",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    },
    transform: "translate(0,1.3229167)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.28810185,
      strokeOpacity: 1
    },
    id: "rect4518-85-9",
    width: 27.78125,
    height: 27.78125,
    x: 0,
    y: -1.3229165
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#0073cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.2606636,
      strokeOpacity: 1
    },
    id: "rect4518-85-3",
    width: 25.135416,
    height: 25.135416,
    x: 1.3229166,
    y: -1.5894571e-7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578703,
      strokeOpacity: 1
    },
    id: "rect4518-85",
    width: 19.84375,
    height: 19.84375,
    x: 3.96875,
    y: 2.6458333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#472a0f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834875,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-0",
    width: 17.197916,
    height: 17.197916,
    x: 5.2916665,
    y: 3.9687507
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.23597811,
      strokeOpacity: 1
    },
    d: "m 14.724294,8.7088066 c -0.841121,0 -2.171988,2.2651724 -2.173511,2.7823874 -0.0015,0.517215 1.557048,1.67028 1.557048,2.017598 0,0.34731 -0.03874,0.657045 -0.474943,0.657045 -0.436196,0 -1.959015,-3.09711 -2.420007,-3.097095 -0.460993,1.5e-5 -3.6982822,3.459892 -3.2753812,4.19238 0.4229008,0.73248 11.5916312,0.544927 11.9062482,0 0.314618,-0.544935 -4.278333,-6.5523154 -5.119454,-6.5523154 z",
    id: "rect4563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteCoreTerrestrialSelected);
export default __webpack_public_path__ + "static/media/icon-site-core-terrestrial-selected.dc8de51f2b24c0d4ff7c637ba6113f80.svg";
export { ForwardRef as ReactComponent };